export const fullUrl = (url: any) => {
  if (/^(ftp|http|https):\/\/[^ "]+$/.test(url)) {
    return url;
  }
  return `http://${url}`;
};
